import { Card, CardContent, Grid2, Typography } from "@mui/material";

const RealTimeViewer2 = ({
	totalAdjustments,
	totalTons,
	totalCobbles,
}: {
	totalAdjustments?: number;
	totalTons?: number;
	totalCobbles?: number;
}) => {
	return (
		<>
			<Card
				sx={{
					width: 250,
					height: 110,
				}}
				elevation={1}
			>
				<CardContent>
					<Grid2 container direction="column">
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Typography
								fontWeight={"bold"}
								sx={{
									userSelect: "none",
								}}
							>
								Billet Tons
							</Typography>
							<Typography>
								{totalTons != null
									? `${parseFloat(totalTons.toFixed(3))}`
									: "-"}
							</Typography>
						</Grid2>
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Typography
								fontWeight={"bold"}
								sx={{
									userSelect: "none",
								}}
							>
								Total Cobbles
							</Typography>
							<Typography>
								{totalCobbles != null ? `${totalCobbles}` : "-"}
							</Typography>
						</Grid2>
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Typography
								fontWeight={"bold"}
								sx={{
									userSelect: "none",
								}}
							>
								Total Adjustments
							</Typography>
							<Typography>
								{totalAdjustments != null ? `${totalAdjustments}` : "-"}
							</Typography>
						</Grid2>
					</Grid2>
				</CardContent>
			</Card>
		</>
	);
};

export default RealTimeViewer2;
